<template>
  <b-card>
    <b-form @submit.prevent="savePassword">
      <b-row>
        <b-col md="6">
          <b-form-group label="Old Password" label-for="account-old-password">
            <b-form-input
              id="account-old-password"
              v-model="passwordValueOld"
              type="password"
              placeholder="Old Password"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6">
          <b-form-group label="New Password" label-for="account-new-password">
            <b-form-input
              id="account-new-password"
              v-model="newPasswordValue"
              type="password"
              placeholder="New Password"
            />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group label="Retype New Password" label-for="account-retype-new-password">
            <b-form-input
              id="account-retype-new-password"
              v-model="retypePassword"
              type="password"
              placeholder="New Password"
            />
          </b-form-group>
        </b-col>
        <b-col md="6" v-if="otpRequired">
          <b-form-group label="Verification Code" label-for="account-otp">
            <b-input-group>
              <b-form-input
                id="account-otp"
                v-model="otpValue"
                maxlength="6"
                placeholder="6-digit code"
              />
              <b-input-group-append>
                <b-button variant="outline-primary" @click="sendOtp">Send code</b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-button variant="primary" class="mt-1 mr-1" :disabled="saving" @click="savePassword">
            Save changes
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </b-card>
</template>

<script>
import {
  BButton, BForm, BFormGroup, BFormInput, BRow, BCol, BCard, BInputGroup, BInputGroupAppend,
} from 'bootstrap-vue'
import commonApi from '@/services/api'

export default {
  components: {
    BButton,
    BForm,
    BFormGroup,
    BFormInput,
    BRow,
    BCol,
    BCard,
    BInputGroup,
    BInputGroupAppend,
  },
  data() {
    return {
      passwordValueOld: '',
      newPasswordValue: '',
      retypePassword: '',
      otpValue: '',
      otpRequired: false,
      saving: false,
    }
  },
  mounted() {
    this.checkOtpRequired()
  },
  methods: {
    checkPassword(str) {
      const re = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/
      return re.test(str)
    },
    async checkOtpRequired() {
      try {
        const resp = await commonApi.sendPasswordResetOtp()
        if (resp?.success) {
          this.otpRequired = Boolean(resp.data?.required)
        }
      } catch (e) {
        this.otpRequired = false
      }
    },
    async sendOtp() {
      await commonApi.sendPasswordResetOtp({ send: true })
      this.$bvToast.toast('Verification code sent to your email', { title: 'Success', variant: 'success' })
      this.otpRequired = true
    },
    async savePassword() {
      if (!this.checkPassword(this.newPasswordValue)) {
        this.$bvToast.toast('Password must be 8+ chars with upper, lower, number, and special character.', { title: 'Error', variant: 'danger' })
        return
      }
      if (this.newPasswordValue !== this.retypePassword) {
        this.$bvToast.toast('Passwords do not match', { title: 'Error', variant: 'danger' })
        return
      }
      this.saving = true
      try {
        const payload = {
          oldPassword: this.passwordValueOld,
          newPassword: this.newPasswordValue,
        }
        if (this.otpRequired) payload.otp = this.otpValue
        const resp = await commonApi.resetPassword(payload)
        if (resp?.success) {
          this.passwordValueOld = ''
          this.newPasswordValue = ''
          this.retypePassword = ''
          this.otpValue = ''
          this.$bvToast.toast('Password updated', { title: 'Success', variant: 'success' })
        }
      } catch (e) {
        this.$bvToast.toast('Could not update password', { title: 'Error', variant: 'danger' })
      } finally {
        this.saving = false
      }
    },
  },
}
</script>
